import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgLogoYugo({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 32 32"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.85 25.14c.18.23.34.52.46.85a4.51 4.51 0 013.04-.13c2.35.78 3.96 3.14 4.44 6.14h.2c.74 0 1.45-.05 2.16-.14a6.87 6.87 0 011.19-3.71c3.3-4.8 8.34-2.1 12.17-8.22a16.04 16.04 0 00-.39-9.18C25.1 9.35 17.47 3.83 18.87.25a16.1 16.1 0 00-4.89-.12c1.53 1.9 1.56 5.05-1.23 5.66-1.77.38-3.74-.18-5.86.18-.09.43-.14.9-.16 1.41-.09 2.52-1.1 4.2-3.54 4.7-1.85.37-2.73 1.33-3.12 2.38-.04.48-.07.97-.07 1.46v.16c0 1.15.13 2.26.37 3.34l.04.2.02.08c1.4 3.04 5.12 2.53 7.42 5.44zm11.31-1.85a2.04 2.04 0 110-4.07 2.04 2.04 0 010 4.07zm6.12-9.98a2.72 2.72 0 11-.01 5.44 2.72 2.72 0 010-5.44zm-6.12 0h3.06v1.36h-.7a2.72 2.72 0 11-2.35-1.36zm-8.83 0h1.36v2.72c0 .74.61 1.35 1.36 1.35.75 0 1.36-.63 1.36-1.38v-2.7h1.36v2.73a2.72 2.72 0 01-5.44 0V13.3zm-6.2 0H5.5v1.36c0 .75.6 1.36 1.35 1.36.75 0 1.36-.64 1.36-1.4v-1.32h1.36v1.36c0 1.26-.87 2.33-2.04 2.63v1.44H6.18V17.3a2.72 2.72 0 01-2.04-2.63V13.3z"
        fill="#402E52"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.16 20.58a.68.68 0 100 1.36.68.68 0 000-1.36m6.12-3.2a1.36 1.36 0 100-2.72 1.36 1.36 0 000 2.72m-6.1 0a1.36 1.36 0 100-2.72 1.36 1.36 0 000 2.72"
        fill="#402E52"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.34 28.15a6.87 6.87 0 00-1.2 3.7 16.02 16.02 0 0013.37-11.92c-3.83 6.12-8.88 3.41-12.17 8.22"
        fill="#FF8C9C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.12 10.11a15.9 15.9 0 00-1.05 4.35c.39-1.05 1.27-2.01 3.12-2.39 2.44-.49 3.45-2.17 3.54-4.69.02-.51.07-.98.16-1.41-1.82.3-3.75 1.3-5.77 4.14m4.26 17.86A8.22 8.22 0 018.31 26a3.33 3.33 0 00-.46-.85c-2.3-2.91-6.03-2.4-7.42-5.44a16 16 0 004.95 8.27"
        fill="#2940EB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.87.26c-1.4 3.57 6.23 9.09 12.25 10.5A16.02 16.02 0 0018.87.25"
        fill="#FF544A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.35 25.86c-1-.34-2.05-.24-3.04.13a8.22 8.22 0 00-2.93 1.98A16.05 16.05 0 0015.78 32c-.47-3-2.08-5.36-4.43-6.14"
        fill="#FFC442"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.98.13a16.04 16.04 0 00-12.86 9.99c2.02-2.85 3.95-3.84 5.77-4.15 2.12-.36 4.09.2 5.86-.18 2.8-.6 2.76-3.76 1.23-5.66"
        fill="#4FE0BF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.28 18.74a2.72 2.72 0 10-.01-5.44 2.72 2.72 0 000 5.44m0-4.07a1.36 1.36 0 110 2.72 1.36 1.36 0 010-2.72m-12.22 4.07c1.5 0 2.72-1.22 2.72-2.71V13.3H14.4V16c0 .75-.61 1.38-1.36 1.38-.75 0-1.36-.6-1.36-1.35V13.3h-1.36v2.72c0 1.5 1.22 2.71 2.72 2.71M6.18 17.3v1.44h1.35V17.3a2.72 2.72 0 002.04-2.63V13.3H8.21v1.33c0 .75-.6 1.39-1.36 1.39-.74 0-1.35-.61-1.35-1.36V13.3H4.14v1.36c0 1.26.87 2.33 2.04 2.63m12.98 1.93a2.04 2.04 0 100 4.08 2.04 2.04 0 000-4.08m0 2.72a.68.68 0 110-1.36.68.68 0 010 1.36m0-3.2a2.72 2.72 0 002.35-4.07h.7V13.3h-3.05a2.72 2.72 0 000 5.43m.02-4.07a1.36 1.36 0 110 2.72 1.36 1.36 0 010-2.72"
        fill="#fff"
      />
    </svg>
  );
}

SvgLogoYugo.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgLogoYugo.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgLogoYugo svgRef={ref} {...props} />);
export default ForwardRef;
